// T-184: which install help a browser gets. Pure (no DOM), so it is tested in node.

/** installed: opened from the installed app; ready: the browser offers its install prompt (Chromium: Chrome, Edge,
 *  Samsung, Android); ios: Safari on iPhone/iPad, which installs only through Share → Add to Home Screen; manual: any other
 *  browser — the steps for Chrome/Edge's address bar, or open the site in one of them. */
export type InstallState = 'installed' | 'ready' | 'ios' | 'manual';

export interface InstallEnv {
  /** display-mode: standalone (or iOS navigator.standalone) */
  standalone: boolean;
  /** a beforeinstallprompt event is held */
  canPrompt: boolean;
  userAgent: string;
  /** navigator.maxTouchPoints — an iPad reports itself as a Mac with touch */
  touchPoints: number;
}

export function installState(env: InstallEnv): InstallState {
  if (env.standalone) return 'installed';
  if (env.canPrompt) return 'ready';
  const ios = /iPad|iPhone|iPod/.test(env.userAgent) || (/Macintosh/.test(env.userAgent) && env.touchPoints > 1);
  return ios ? 'ios' : 'manual';
}
